<template>
    <ul :class="`grid grid-1-2-${count} gap-05rem`">
        <li class="product-list__item" v-for="i in count" :key="i">
            <Skeleton :width="width" :height="height" />
        </li>
    </ul>
</template>

<script setup>
import { Skeleton } from 'primevue';
const props = defineProps({
    count: {
        type: Number,
        required: true,
        default: 1,
    },
    width: {
        type: String,
        required: true,
    },
    height: {
        type: String,
        required: true,
    },
});
</script>
